import React, { createContext, ReactNode, useContext, useState } from "react";

interface ExternalChangeContextType {
  isExternalChangeInProcess: boolean;
  setExternalChangeInProcess?: (inProcess: boolean) => void;
}

const ExternalChangeContext = createContext<ExternalChangeContextType | undefined>(undefined);

interface ExternalChangeProviderProps {
  children: ReactNode;
}

export const ExternalChangeProvider: React.FC<ExternalChangeProviderProps> = ({ children }) => {
  const [isExternalChangeInProcess, setIsExternalChangeInProcess] = useState<boolean>(false);

  const setExternalChangeInProcess = (inProcess: boolean) => {
    setIsExternalChangeInProcess(inProcess);
  };

  const value: ExternalChangeContextType = {
    isExternalChangeInProcess,
    setExternalChangeInProcess,
  };

  return <ExternalChangeContext.Provider value={value}>{children}</ExternalChangeContext.Provider>;
};

export const useExternalChange = (): ExternalChangeContextType => {
  const context = useContext(ExternalChangeContext);
  if (context === undefined) {
    return {
      isExternalChangeInProcess: false,
    };
  }
  return context;
};

export const withExternalChanges =
  <P extends object>(Component: React.ComponentType<P>): React.FC<P> =>
  (props: P) => (
    <ExternalChangeProvider>
      <Component {...props} />
    </ExternalChangeProvider>
  );
